import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SitesHomeComponent } from './sites-home/sites-home.component';

import { SitesListComponent } from './sites-list/sites-list.component';

const routes: Routes = [
  {
    path: '',
    component: SitesHomeComponent,
    children: [
      {
        path: '',
        component: SitesListComponent
      },
      // {
      //   path: '/:id',
      //   component: SitesListComponent
      // },
    ]
  }
];



@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SitesRoutingModule { }
